// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__sRz_s","col":"styles_col__2VQ_q"};